import React from "react";
import CommonTooltip from "./CommonTooltip";

const toneClasses = {
  blue: "text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900/30",
  red: "text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/30",
  amber:
    "text-amber-600 hover:bg-amber-50 dark:text-amber-400 dark:hover:bg-amber-900/30",
  emerald:
    "text-emerald-600 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:bg-emerald-900/30",
  gray: "text-gray-600 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-700/40",
};

// Opt-in via `tooltipText` so the call sites that don't pass it are unaffected. The bubble is
// the shared blue CommonTooltip, same as every other button in the app.
const ActionIconButton = ({
  children,
  onClick,
  disabled = false,
  tone = "gray",
  className = "",
  ariaLabel,
  type = "button",
  tooltipText,
  tooltipPosition = "top",
  tooltipClassName = "w-max max-w-[min(12rem,calc(100vw-1.5rem))] [text-wrap:balance]",
  ...rest
}) => {
  const toneClass = toneClasses[tone] || toneClasses.gray;

  const button = (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#236DB4]/30 ${toneClass} ${
        disabled ? "cursor-not-allowed opacity-50" : ""
      } ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );

  if (!tooltipText) {
    return <div className="relative inline-block">{button}</div>;
  }

  return (
    <CommonTooltip
      text={tooltipText}
      position={tooltipPosition}
      disableDefaultDescription
      className="relative inline-block"
      tooltipClassName={tooltipClassName}
      fitContent
      clampToViewport
      hoverOnly
    >
      {button}
    </CommonTooltip>
  );
};

export default ActionIconButton;
